module.exports = __webpack_public_path__ + "61c06908aaaff72675d0dd4373277fdc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/trash.svg
// module id = 787
// module chunks = 0